import { Box } from "@mui/material";
import React from "react";

const AppFormHeader = ({ header }) => {
  return <Box sx={{ fontWeight: "bold", height: "30px" }}>{header}</Box>;
};

export default AppFormHeader;
